export const CHATROOM_SYSTEM_MESSAGE_TYPE = {
  AcadoroMessage: 7,
  AddUser: 0,
  AddUserWithComment: 3,
  KickUser: 1,
  ProviderMessageFailed: 6,
  ProviderMessageSent: 5,
  RequestExportToIgel: 4,
  UserLeft: 2,
}

export const CHATROOM_SYSTEM_MESSAGE_TRANSLATION_KEY = {
  [CHATROOM_SYSTEM_MESSAGE_TYPE.AcadoroMessage]:
    'Chatroom.SystemMessageAcadoroKey',
  [CHATROOM_SYSTEM_MESSAGE_TYPE.AddUser]: 'Chatroom.SystemMessageUserAddedKey',
  [CHATROOM_SYSTEM_MESSAGE_TYPE.AddUserWithComment]:
    'Chatroom.SystemMessageUserAddedWithCommentTextKey',
  [CHATROOM_SYSTEM_MESSAGE_TYPE.KickUser]:
    'Chatroom.SystemMessageUserKickedKey',
  [CHATROOM_SYSTEM_MESSAGE_TYPE.ProviderMessageFailed]:
    'Chatroom.SystemMessageProviderFailedKey',
  [CHATROOM_SYSTEM_MESSAGE_TYPE.ProviderMessageSent]:
    'Chatroom.SystemMessageProviderSentKey',
  [CHATROOM_SYSTEM_MESSAGE_TYPE.RequestExportToIgel]:
    'Chatroom.SystemMessageRequestExportToIgelKey',
  [CHATROOM_SYSTEM_MESSAGE_TYPE.UserLeft]: 'Chatroom.SystemMessageUserLeftKey',
}
